export default "__VITE_ASSET__CZTtbIl6__"